import React, { lazy } from 'react';
import { ComplextRoute } from 'router/components/Routes/Routes';

const Sell = lazy(() => import('./pages/Sell'));
const SellAuthCallback = lazy(() => import('./pages/SellAuthCallback'));
const SellerIm = lazy(() => import('./pages/SellerIm'));

export default [
  {
    index: true,
    element: <Sell />,
  },
  {
    path: 'auth/callback',
    element: <SellAuthCallback />,
  },
  {
    path: 'im/:submissionId',
    element: <SellerIm />,
  },
] as Array<ComplextRoute>;
